import {SODeleteCustomLogicRequirement} from '../../core/custom-logic-requirement/so-delete-custom-logic-requirement';
import {DeleteEntityProtocol} from 'lionheartland';
import {BaseDelete} from 'lionheartland';


export class RADeleteCustomLogicRequirement extends BaseDelete implements DeleteEntityProtocol {
  deleteClass = SODeleteCustomLogicRequirement;
}